module.exports = __webpack_public_path__ + "img/RI_20260826-01.9159d13c.svg";